import { useNavigate } from "react-router-dom";

import { ModuleSubHead } from "../../components/other";

import ImgHome1 from "../../images/other/home_1.jpg";

import { Button } from "primereact/button";

export default function FrontHome() {
  const route_navigate = useNavigate();

  return (
    <>
      <div className="flex flex-column h-full">
        <ModuleSubHead isDefault={true} lineType="multi" />

        <div className="flex justify-content-center md:align-items-center flex-auto px-4">
          <div className="flex flex-column md:flex-row md:align-items-end w-12 lg:w-10 xl:w-9 mt-4 md:mt-0">
            <img
              className="w-10rem lg:w-13rem -mt-5 md:mt-0 md:-mb-3 flex-order-1 md:flex-order-0"
              src={ImgHome1}
              alt="資訊討論"
            />

            <div className="md:ml-6 flex-order-0 md:flex-order-1">
              <div className="relative text-center md:text-right">
                <div className="absolute top-50 left-0 w-full border-bottom-2 border-500"></div>
                <span className="md:mr-6">
                  <span className="relative text-6xl font-bold text-main bg-white md:mr-6 px-3">
                    醫師和家長
                  </span>
                </span>
              </div>

              <div className="text-6xl font-bold my-4 md:my-6">
                交換資訊討論，達成最佳可行治療
              </div>

              <div className="border-1 border-400 text-2xl p-3">
                兒童近視治療共享決策是讓醫護人員和家長在進行兒童近視治療決策前，能以現有實證結果及醫療專業為基礎，提供家長近視治療資訊、所有可行的治療方案，並幫助家長提出自己在意的考量及期待。
              </div>

              <div className="text-right mt-3">
                <Button
                  className="p-button-lg p-button-main px-4"
                  type="button"
                  label="開始評估"
                  onClick={() => route_navigate("chooseForm")}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="text-md text-right">
          <div>國科會專題研究計畫</div>
          <div>MOST111-2314-B-255-004-MY3版權所有</div>
          <div>長庚學校財團法人長庚科技大學護理系張麗春教授研究團隊</div>
        </div>
      </div>
    </>
  );
}
